import { TipoEsito } from "./tipologiche/tipo-esito";

export class DettaglioAdempimento {
    id: string;
    tipoEsito: TipoEsito;
    esitoDescrizione: string;
    numeroEsito: string;
    annoEsito: string;   
    dataPubblicazione: number;
}
